/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */

export const getAllFields = (fieldValues) => {
  const fieldList = [];
  const excludeList = ['validations', 'id'];

  Object.keys(fieldValues).forEach((key) => {
    if (!excludeList.includes(key)) {
      fieldList.push(key);
    } else {
      Object.keys(fieldValues[key]).forEach((newKey) => {
        fieldList.push(newKey);
      });
    }
  });

  return fieldList;
};

export const formTemplatesArrayToObject = (formTemplatesArray) => {
  const formTemplatesMap = new Map();
  formTemplatesArray.forEach((template) => {
    formTemplatesMap.set(template.id, template);
  });

  return Object.fromEntries(formTemplatesMap);
};

export const filterFormTemplatesByActive = (formTemplates, activeState = 'any') => {
  switch (activeState) {
    case 'active':
      return formTemplatesArrayToObject(Object.values(formTemplates).filter((template) => template.active === true));
    case 'inactive':
      return formTemplatesArrayToObject(Object.values(formTemplates).filter((template) => template.active === false));
    default:
      return formTemplates;
  }
};

export const charTypes = {
  letters: { text: 'abc', symbol: 'A', regex: '[a-zA-Z]{1}' },
  numbers: { text: '123', symbol: '#', regex: '\\d{1}' },
  letters_and_numbers: {
    text: 'abc/123',
    symbol: 'A/#',
    regex: '([a-zA-Z]|\\d){1}',
  },
  hyphen: { text: '-', symbol: '-', regex: '-' },
};

export const charTypeRequester = (givenItem, requestedVariation) => {
  let givenType;
  for (const type in charTypes) {
    for (const variation in charTypes[type]) {
      if (charTypes[type][variation] === givenItem) {
        givenType = type;
      }
    }
  }
  return charTypes[givenType][requestedVariation];
};

export const getCharTypeFromKey = (requestedKey) => {
  const exps = [];
  for (const key in charTypes) {
    exps.push(charTypes[key][requestedKey]);
  }
  return exps;
};

const determineNextExp = (exps, stringExp) => {
  let nextExp = null;
  exps.forEach((exp, index) => {
    if (stringExp.indexOf(exp) === 0) {
      nextExp = index;
    }
  });
  return nextExp;
};

export const regexParser = (stringReg, characterLimit) => {
  const parsedExps = new Array(characterLimit).fill('');
  let stringRegCopy = stringReg.repeat(1);
  const charTypeExps = getCharTypeFromKey('regex');
  let nextToParse = null;
  return parsedExps.map((parsedExp) => {
    if (stringRegCopy.length > 0) {
      nextToParse = determineNextExp(charTypeExps, stringRegCopy);
      stringRegCopy = stringRegCopy.replace(charTypeExps[nextToParse], '');
      return charTypeExps[nextToParse].repeat(1);
    }
    return parsedExp;
  });
};

export const displayAPIError = (formTemplateRequestError) => {
  if (Object.entries(formTemplateRequestError).length === 0) return false;
  return true;
};

export const getLatestFormTemplateVersion = (template) => {
  // the server response has the versions ordered from latest to oldest
  return template.versions?.[0];
};

export const formTemplateHasTrialContainer = (formTemplate, trialContainerId) => {
  if (formTemplate === undefined) return false;

  return formTemplate.trial_containers.filter((trialContainer) => trialContainer.id === trialContainerId).length > 0;
};

export const requiredFormTemplateInUse = (formTemplate, trialContainerId) => {
  if (formTemplate === undefined) return false;

  return formTemplate.required_template_in_use.includes(trialContainerId);
};

export const templateVersionExists = (versionNo, formTemplate) => {
  return formTemplate.versions.filter((template) => template.version_number === parseInt(versionNo, 10)).length > 0;
};

export const selectTemplateByVersionNo = (versionNo, formTemplate) => {
  if (!templateVersionExists(versionNo, formTemplate)) return false;
  return formTemplate.versions.filter((template) => template.version_number === parseInt(versionNo, 10))[0];
};

export const getFormTemplateById = (templateId, formTemplates) => {
  return formTemplates[templateId];
};

export const formTemplatesContainerPosition = {
  xCord: 0,
  yCord: 180,
};
